import ClientType from '@/modules/common/enums/client-type.ts';

export const COUNTERPARTY_INN_SEARCH_TYPES: ReadonlySet<number> = new Set([
  ClientType.Legal,
  ClientType.IP,
  ClientType.OwnLegal,
]);

export const COUNTERPARTY_LEGAL_ENTITY_TYPES: ReadonlySet<number> = new Set([ClientType.Legal, ClientType.OwnLegal]);

export function isCounterpartyInnSearchType(typeId: number | null | undefined) {
  return typeof typeId === 'number' && COUNTERPARTY_INN_SEARCH_TYPES.has(typeId);
}

export function isCounterpartyLegalEntityType(typeId: number | null | undefined) {
  return typeof typeId === 'number' && COUNTERPARTY_LEGAL_ENTITY_TYPES.has(typeId);
}
